<template>
  <div style="height: 100%;">
    <v-container class="center-content" fill-height>

      <v-col align="center" class="fill-hight">
        <v-col>
          <v-img alt="Cellsmart Logo" class="shrink mr-2" contain src="@/assets/fullLogo.png"
            transition="scale-transition" width="250" />
        </v-col>

        <v-col>
          <div class="font-weight-bold title">Accounts</div>
        </v-col>

        <v-col cols="12" md="6">
          <v-card outlined>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <span class="subheading">Welcome Back</span>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="email" outlined dense :error-messages="emailErrors" label="Email"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field outlined dense v-model="password"
                    :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                    :type="showPassword ? 'text' : 'password'" label="Password" v-on:keyup.enter.prevent="submit"
                    :error-messages="passwordErrors" @input="$v.password.$touch()" counter
                    @click:append="showPassword = !showPassword"></v-text-field>
                </v-col>

              </v-row>
            </v-card-text>
          </v-card>
          <v-btn :loading="loading" v-on:click.stop="submit" class="mt-3 mb-3 v-btn-with-radius" color="info" large
            block>Login</v-btn>
          <v-row>
            <v-col>
              <router-link data-cy="loginForgotPassword" style="text-decoration: none"
                to="/backoffice/forgotPassword">Forgot
                Password</router-link>
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <router-link to="/home">Back To Time Clock</router-link>
            </v-col>
          </v-row>

        </v-col>


      </v-col>

      <!-- <v-layout column justify-center align-center>
        <v-flex shrink class="mt-16">
          <v-img alt="Cellsmart Logo" class="shrink mr-2" contain src="@/assets/fullLogo.png"
            transition="scale-transition" width="250" />
        </v-flex>
        <div class="subheading mt-2 mb-15">Accounts</div>
      </v-layout> -->

      <!-- <v-card-text>
        <div class="text-center">
          <v-flex class="mb-3">
            <span class="subheading">Welcome Back</span>

          </v-flex>
          

          <v-flex>
            <v-text-field v-model="email" outlined dense :error-messages="emailErrors" label="Email"></v-text-field>
          </v-flex>
          <v-flex>
            <v-text-field outlined dense v-model="password"
              :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
              :type="showPassword ? 'text' : 'password'" label="Password" v-on:keyup.enter.prevent="submit"
              :error-messages="passwordErrors" @input="$v.password.$touch()" counter
              @click:append="showPassword = !showPassword"></v-text-field>
          </v-flex>

          <v-btn v-on:click.stop="submit" class="mt-3 mb-3 v-btn-with-radius" color="info" large block>Login</v-btn>

          <router-link data-cy="loginForgotPassword" style="text-decoration: none" to="/backoffice/forgotPassword">Forgot
            Password</router-link>

          <br>

          <dir class="mt-4">
            <router-link to="/home">Back To Time Clock</router-link>
          </dir>
        </div>
      </v-card-text> -->


    </v-container>
    <v-footer app color="#F3F8FC">
      <v-layout align-center justify-center column fill-heigh>
        <div class="text-xs-center mb-3 mt-3">
          Don't have account?
          <a href="javascript:void(0)" @click="signUp">
            <b data-cy="loginSignUp">Sign Up</b>
          </a>
        </div>
      </v-layout>
    </v-footer>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import authService from "@/modules/BackOffice/service.js";
// import GoogleLogin from './GoogleLogin';

const { validationMixin } = require("vuelidate");
const { required, email } = require("vuelidate/lib/validators");

export default {
  name: "authentication-login",
  data() {
    return {
      loading: false,
      showPassword: false,
      email: null,
      password: null,
    };
  },
  // components: {
  //   GoogleLogin,
  // },
  async created() {
    localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}orgToken`);
  },
  methods: {
    ...mapActions("global", ["initOrganization"]),
    signUp() {
      this.$router.push({ path: "/signup" });
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$toast.error("Invalid Input", {
          timeout: 2000,
        });
      } else {
        this.loading = true
        this.$Progress.start();
        return authService
          .authenticate({
            email: this.email,
            password: this.password,
          }, true)
          .then((response) => {
            this.loading = false
            console.log('response', response)
            this.$Progress.finish();
            this.checkResponse(response);
          })
          .catch((error) => {
            this.loading = false
            this.$Progress.finish();
            console.log(error);
            this.$swal("Invalid Login", "Check email and password and try again", "error");
          });
      }
    },
    checkResponse(response) {
      localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}backofficeToken`, response.data.token)

      // set the organization id or ask for the selection
      if (
        response.data &&
        response.data.user &&
        response.data.user.Organizations.length === 1
      ) {
        localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}organizationId`, response.data.user.Organizations[0].id)
        // localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}backofficeToken`, response.data.token)
        // return this.initOrganization(response.data.user.Organizations[0])
        //   .then(() => {
        //     this.$router.push({ path: "/account" });
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
        console.log('in here 1 org')
        this.$router.push({ path: '/backoffice' });
        return
      }
      if (
        response.data &&
        response.data.user &&
        response.data.user.Organizations.length > 1
      ) {
        console.log('im here in more organization')
        this.$router.push({
          name: "authentication-select-organization",
          params: {
            Organizations: response.data.user.Organizations,
          },
        });
      } else if (response.data && response.data.user) {
        console.log('no organization found')
        this.$router.push({ path: "/backoffice/newOrganization" });
      } else {
        // Do nothing
        this.$toast.error("Invalid Login Request", {
          timeout: 2000,
        });
      }
    },
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.email) errors.push("Email is not valid");
      if (!this.$v.email.required) errors.push("Email is required.");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      if (!this.$v.password.required) errors.push("Password is required.");
      return errors;
    },
  },
  mixins: [validationMixin],
  validations: {
    email: {
      email,
      required,
    },
    password: {
      required,
    },
  },
};
</script>
